// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__74tzL","right":"styles_right__20mC0"};